import { Box, Typography, } from "@mui/material";

const LaydownList = ({ currentLaydown, setCurrentLaydown, laydownList, isEditMode = false }) => {

    const handleLaydownClick = (item) => {
        // Only allow click if not in edit mode
        if (!isEditMode) {
            setCurrentLaydown(item);
        }
    };

    return (
         <Box>
              <Typography fontSize={20} mb={2} fontWeight={600}>
                {"Laydown List"}
              </Typography>
              <Box>
                {laydownList?.map((item, index) => {
                  const isActive = currentLaydown?.id === item.id;
                  return (
                    <Box
                      onClick={() => handleLaydownClick(item)}
                      key={index}
                      p={1}
                      mb={0.5}
                      fontWeight={500}
                      sx={{
                        borderRadius: 1,
                        backgroundColor: isActive ? "#e5e7eb" : "transparent",
                        color: isActive ? "#000" : "inherit",
                        cursor: isEditMode ? "not-allowed" : "pointer",
                        opacity: isEditMode ? 0.6 : 1,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        "&:hover": {
                          backgroundColor: isEditMode ? (isActive ? "#e5e7eb" : "transparent") : "#e5e7eb",
                          color: isActive ? "#000" : "inherit",
                        },
                      }}
                    >
                      <span>{item?.name}</span>
                      {isActive && (
                        <Box
                          sx={{
                            width: 10,
                            height: 10,
                            backgroundColor: "green",
                            borderRadius: "50%",
                            marginLeft: 1,
                          }}
                        />
                      )}
                    </Box>
                  );
                })}
              </Box>
            </Box>
    );
};

export default LaydownList;